import { Add, Remove, Straighten } from '@mui/icons-material';
import { Stack, Tooltip } from '@mui/material';
import { setGeofenceMode, setLayerSelected, setZoom } from 'app/actions/map';
import { FabButton, Protect } from 'app/components';
import { CircleGeofenceIcon, DragGeofenceIcon, EditGeofenceIcon, MapLayerRoundedIcon, PolygonGeofenceIcon } from 'app/icons';
import { MapLeafletLayerMenu } from 'app/pages/Map';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapLeafletControls = () => {
  const dispatch = useDispatch();
  const { ref: mapRef, filterTab, geofenceMode } = useSelector((state) => state.map);
  const [anchorMapLayerEl, setAnchorMapLayerEl] = useState(null);
  const [mapRulerMode, setMapRulerMode] = useState(false);

  const handleMapLayerOpen = (event) => {
    setAnchorMapLayerEl(event.currentTarget);
  };

  const handleMapLayerClose = () => {
    setAnchorMapLayerEl(null);
  };

  const handleMapLayerClick = (value) => {
    setAnchorMapLayerEl(null);
    dispatch(setLayerSelected(value));
  };

  const handleMapGeofenceModeClick = (value) => dispatch(setGeofenceMode(geofenceMode !== value ? value : ''));

  const handleZoomInClick = () => dispatch(setZoom(mapRef.current.getZoom() + 1));

  const handleZoomOutClick = () => dispatch(setZoom(mapRef.current.getZoom() - 1));

  const handleRulerClick = () => {
    setMapRulerMode(!mapRulerMode);
    mapRef.current.handleRulerMode();
  };

  return (
    <Stack
      direction='column'
      alignItems='center'
      justifyContent='center'
      sx={(theme) => ({
        position: 'absolute',
        right: theme.spacing(3),
        top: '0',
        height: '100%',
        zIndex: '1010',
      })}>
      <Stack spacing={1} mb={3}>
        <Tooltip title='Линейка' placement='left' arrow enterDelay={800}>
          <FabButton size='small' active={mapRulerMode} onClick={handleRulerClick}>
            <Straighten />
          </FabButton>
        </Tooltip>
        <Tooltip title='Увеличить' placement='left' arrow enterDelay={800}>
          <FabButton size='small' onClick={handleZoomInClick}>
            <Add />
          </FabButton>
        </Tooltip>
        <Tooltip title='Уменьшить' placement='left' arrow enterDelay={800}>
          <FabButton size='small' onClick={handleZoomOutClick}>
            <Remove />
          </FabButton>
        </Tooltip>
        <Tooltip title='Слои' placement='left' arrow enterDelay={800}>
          <FabButton size='small' active={!!anchorMapLayerEl} onClick={handleMapLayerOpen}>
            <MapLayerRoundedIcon />
          </FabButton>
        </Tooltip>
        <MapLeafletLayerMenu
          anchorEl={anchorMapLayerEl}
          open={!!anchorMapLayerEl}
          onClose={handleMapLayerClose}
          onChange={handleMapLayerClick}></MapLeafletLayerMenu>
      </Stack>
      {filterTab === 'geofence' && (
        <Stack spacing={1}>
          <Protect
            permissions='create'
            renderPermitted={() => (
              <Tooltip title='Нарисовать полигон' placement='left' arrow enterDelay={800}>
                <FabButton size='small' active={geofenceMode === 'Poly'} onClick={() => handleMapGeofenceModeClick('Poly')}>
                  <PolygonGeofenceIcon />
                </FabButton>
              </Tooltip>
            )}
            renderForbidden={() => <React.Fragment />}
          />
          <Protect
            permissions='create'
            renderPermitted={() => (
              <Tooltip title='Нарисовать круг' placement='left' arrow enterDelay={800}>
                <FabButton size='small' active={geofenceMode === 'Circle'} onClick={() => handleMapGeofenceModeClick('Circle')}>
                  <CircleGeofenceIcon />
                </FabButton>
              </Tooltip>
            )}
            renderForbidden={() => <React.Fragment />}
          />
          <Protect
            permissions='update'
            renderPermitted={() => (
              <Tooltip title='Изменить геозону' placement='left' arrow enterDelay={800}>
                <FabButton size='small' active={geofenceMode === 'Edit'} onClick={() => handleMapGeofenceModeClick('Edit')}>
                  <EditGeofenceIcon />
                </FabButton>
              </Tooltip>
            )}
            renderForbidden={() => <React.Fragment />}
          />
          <Protect
            permissions='update'
            renderPermitted={() => (
              <Tooltip title='Переместить геозону' placement='left' arrow enterDelay={800}>
                <FabButton size='small' active={geofenceMode === 'Drag'} onClick={() => handleMapGeofenceModeClick('Drag')}>
                  <DragGeofenceIcon />
                </FabButton>
              </Tooltip>
            )}
            renderForbidden={() => <React.Fragment />}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default MapLeafletControls;
